import React from 'react'
import { useTranslation } from 'react-i18next'
import { KibCheckOutlineIcon } from '@chewy/kib-icons-react'

import styles from './PaymentSuccessScreenTitle.module.scss'

export const PaymentSuccessScreenTitle = () => {
  const { t } = useTranslation(['Dialogs'])
  return (
    <div className={styles.paymentSuccessTitleContainer}>
      <KibCheckOutlineIcon className={styles.paymentSuccessIcon} />
      {t('Dialogs:ADD_PAYMENT_DIALOG_V2.PAYMENT_SUCCESSFULLY_RECORDED')}
    </div>
  )
}
